var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionWrapper',{attrs:{"title":"VOMS","title-only":""}},[_c('VomsTable',{attrs:{"individual-measure":_vm.profileTest.formattedTestsData['1020']}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }